
export enum DriverAssignmentSource {
    DigiDl = 0,
    Unit = 1,
    ButtonPress = 2,
    ManualAssignment = 3
}
